import { render } from "./ConfigurationForm.vue?vue&type=template&id=79f2bc8c&scoped=true"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js"

import "./ConfigurationForm.vue?vue&type=style&index=0&id=79f2bc8c&scoped=true&lang=css"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f2bc8c"]])

export default __exports__